import gql from 'graphql-tag';

export const GET_PROCESS_BY_ID = gql`
  query ($id: ID!){
    grabGetProcessById(_id: $id) {
      id
      status
      statsGeneral {
        channelsProcessed
        averageLoad
      }
      statsServer {
        server_id
        grabCount
        mdbCount
        grabTotal
        mdbTotal
        threadCount
        entries {
          grabCount
          mdbCount
          reported_at
        }
      }
      created_at
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/grab/fetchById.js